<template lang="pug">

#app
  .panels
    .panel
      .bg.w1
      .copy.
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
    .panel
      .bg.w2
      .copy.
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
    .panel
      .bg.w3
      .copy.
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
        the quick brown fox jumps over the lazy dog
</template>


<script>

// import HelloWorld from "./components/HelloWorld.vue";


export default {

  name: "app",

  components: {

    // HelloWorld

  }

};

</script>


<style lang="scss">

html, body {
  margin: 0;
  padding: 0;
  * {
    box-sizing: border-box;
  }
}
#app {

  font-family: "Avenir", Helvetica, Arial, sans-serif;

  -webkit-font-smoothing: antialiased;

  -moz-osx-font-smoothing: grayscale;

  text-align: center;

  color: #2c3e50;

  margin-top: 0;
  .panels {
    display: flex;
    width: 300vw;
    height: 200vh;
    .panel {
      width: 33%;
      height: 100%;
      .copy {
        white-space: pre;
        padding: 10%;
        background-color: #282828;
        color: white;
        height: 50%;
      }
      .bg {
        height: 50%;
        width: 100%;
        background: no-repeat top center;
        background-size: contain;
        &.w1 {
          background-image: url('./assets/mag1.jpg');
          background-size: 250%;
          background-position-y: -60px;
        }
        &.w2 {
          background-image: url('./assets/mag2.png');
          background-size: 100%;
        }
        &.w3 {
          background-image: url('./assets/mag3.jpg');
          background-size: 130%;
        }
      }
    }
  }

}
</style>
